import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { Form, Formik } from "formik";
import { getBuyBackFeeFormInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/vendotPricingModalUtils";
import DropDown from "web/components/DropDown";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { FormWrapper, TableFormRowWrapper } from "../VendorPricingStyled";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import VendorPricingModal from "../PopUpModals/VendorPricingModal"

const AddVendorPricingCustomerForm = ({
  customerMainLocationList,
  customerSubLocationList,
  getCustomerSubLocationList,
  vendorLocationList,
  refreshData
}) => {
  const history = useHistory()
  // const dispatch = useDispatch()
  const [showVendorPricingModal, setShowVendorPricingModal] = useState(false);

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Formik
        initialValues={getBuyBackFeeFormInitialValues()}
        validationSchema={VALIDATION_SCHEMA()}
      >
        {(formikProps) => {
          const { setFieldValue, values, errors, resetForm } = formikProps;
          const isAddButtonDisabled = !values.customerName || !values.customerLocationId;
          return <>
            <Form className="form-wrapper">
              <FormWrapper>
                <div>
                  <TableFormRowWrapper>
                    <div className="row mb-1">
                      <div className="col-md-4">
                        <DropDown
                          label="Customer Name"
                          placeholder="Customer Name"
                          name="customerName"
                          searchDropDown={values.customerName}
                          searchable={true}
                          data={customerMainLocationList}
                          onChangeHandler={async (value) => {
                            await getCustomerSubLocationList(value.value);
                            setFieldValue("customerLocationId", "");
                            setFieldValue("customerName", value.value);
                            setFieldValue("mainLocationName", value.label);
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <DropDown
                          label="Customer Location Name"
                          placeholder="Customer Location Name"
                          name="customerLocationId"
                          searchDropDown={values.customerLocationId}
                          searchable={true}
                          data={customerSubLocationList}
                          onChangeHandler={async (value) => {
                            setFieldValue("customerLocationId", value.value);
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                          <button type="button" disabled={isAddButtonDisabled} className="add-buyback-fee" onClick={() => setShowVendorPricingModal(true)}><AddPlusIcon />Add Vendor Pricing</button>
                        </div>
                      </div>
                    </div>
                  </TableFormRowWrapper>
                </div>
              </FormWrapper>
              {showVendorPricingModal &&
                <VendorPricingModal
                  closeModal={(type) => {
                    setShowVendorPricingModal(false)
                    if (type === 'addSuccess') refreshData()
                  }}
                  vendorLocationList={vendorLocationList}
                  setFieldValue={setFieldValue}
                  formikValues={values}
                  errors={errors}
                  resetForm={resetForm}
                />
              }
            </Form>
          </>
        }}
      </Formik>
    </>
  )
}

export default AddVendorPricingCustomerForm
